export const esTelefonoValido = (telefono) => {
    if (!telefono) return false;

    const telefonoStr = String(telefono);

    // solo 10 dígitos numéricos, sin espacios ni caracteres
    const regex = /^\d{10}$/;

    return regex.test(telefonoStr);
};